import { types } from "./index.js";

const cache = new Map<string, types.ImageSummary>();

/** Store image summaries from the directory listing for later lookup. */
export function storeImages(images: types.ImageSummary[]) {
  for (const img of images) cache.set(img.name, img);
}

/** Get a cached image summary by name, if available from a prior listing fetch. */
export function getImage(name: string): types.ImageSummary | undefined {
  return cache.get(name);
}
